module.exports = __webpack_public_path__ + "img/fdc.0cfa9d16.png";